import { SnackThumbnailField } from "@/components/features/snack/_shared/ui/thumbnail-field";

import { Button } from "@/components/ui/button/button";
import { Dialog, DialogClose, DialogContent } from "@/components/ui/dialog/dialog";

import type { SnackBlocksFormModelMethodsType } from "../../../../../model/usecase/use-create-snack-layout-settings-form-model/methods";

type Props = {
	bgImageMethods: SnackBlocksFormModelMethodsType["bgImageMethods"];
};

export const IslandLayoutSettingsBgImageUploader = ({ bgImageMethods }: Props) => {
	const {
		activateSelectBgImageModal,
		onOpenChange,
		onSetBgImage,
		deactivateSelectBgImageModal,
		imageRepository,
		imageUploader,
		isShowSelectBgImageModal,
		bgImage,
	} = bgImageMethods;

	return (
		<div className="flex justify-end">
			<Button type="button" size="sm" variant="outline" onClick={activateSelectBgImageModal}>
				背景画像を変更
			</Button>

			<Dialog open={isShowSelectBgImageModal} onOpenChange={onOpenChange}>
				<DialogClose onClick={deactivateSelectBgImageModal} />

				<DialogContent>
					<SnackThumbnailField
						thumbnail={bgImage}
						onSetThumbnail={onSetBgImage}
						imageRepository={imageRepository}
						imageUploader={imageUploader}
					/>
				</DialogContent>
			</Dialog>
		</div>
	);
};

IslandLayoutSettingsBgImageUploader.displayName = "IslandLayoutSettingsBgImageUploader";
